import React, { useEffect, useState } from 'react';
import axios from 'axios';

import './styles/reset.css';
import './styles/style.css';
import './fonts/stylesheet.css';

import LoadingPage from './pages/loading-page/LoadingPage';
import AgePage from './pages/age-page/AgePage';
import NoAccessPage from './pages/no-access-page/NoAccessPage';
import BookingPage from './pages/booking-page/BookingPage';
import MainPage from './pages/main-page/MainPage';
import NavigationPanel from './components/navigation-panel/NavigationPanel';
import ContactPage from './pages/contact-page/ContactPage';
import InfoPage from './pages/info-page/InfoPage';
import DevelopmentPage from './pages/development-page/DevelopmentPage';
import SuccessPage from './pages/success-page/SuccessPage';
import ErrorPage from './pages/error-page/ErrorPage';
import UserPage from './pages/user-page/UserPage';
import PaidPage from './pages/paid-page/PaidPage';
import BonusPage from './pages/bonus-page/BonusPage';
import PaidMethod from './pages/paid-method-page/PaidMethod';
import MenuPage from './pages/menu-page/MenuPage';
import CartPage from './pages/cart-page/CartPage';
import HistoryPage from './pages/history-page/HistoryPage';
import OrderPage from './pages/order-page/OrderPage';
import PopUp from './components/navigation-panel/popup/PopUp';
import ProductPage from './pages/product-page/ProductPage';

function App() {
    const [currentPage, setCurrentPage] = useState('LoadingPage'); // текущая страница
    const [firstUserName, setFirstUserName] = useState(''); // имя пользователя
    const [lastUserName, setLastUserName] = useState(''); // фамилия пользователя
    const [telephoneUser, setTelephoneUser] = useState(''); // телефон пользователя
    const [isShowSuccess, setIsShowSuccess] = useState(false); // отображение подтверждения
    const [successStatus, setSuccessStatus] = useState(0); // статус подтверждения

    const [isShowError, setIsShowError] = useState(false); // отображение ошибки
    const [errorStatus, setErrorStatus] = useState(0); // статус ошибки

    const [isButtonActive, setIsButtonActive] = useState(false); // нажатие на "вызов персонала"

    const [isShowNavigation, setIsShowNavigation] = useState(true); // отображение меню

    const [isUserHavePlace, setIsUserHavePlace] = useState(null); // занял ли пользователь стол
    const [tableId, setTableId] = useState(''); // id стола

    const [isShowProductCard, setIsShowProductCard] = useState(false); // отображение карточки товара

    // сумма корзины
    const [totalSum, setTotalSum] = useState(0);

    const [historyList, setHistoryList] = useState(null); // история заказов
    const [orderList, setOrderList] = useState(null); // заказ
    const [paymentList, setPaymentList] = useState(null); // оплата
    const [userCallTime, setUserCallTime] = useState(null); // таймер

    const [isShowPopUpModal, setIsShowPopUpModal] = useState(false);

    // выбранный товар
    const [selectProduct, setSelectProduct] = useState(null);

    // добавленные продукты
    const [productCount, setProductCount] = useState({});
    const [cartItems, setCartItems] = useState([]);

    // кнопка "назад" тг
    useEffect(() => {
        const tg = window.Telegram.WebApp;

        if (currentPage === 'InfoPage') {
            tg.BackButton.show();
            tg.BackButton.onClick(() => {
                setCurrentPage('ContactPage');
            });
        }

        if (currentPage === 'BookingPage') {
            tg.BackButton.show();
            tg.BackButton.onClick(() => {
                setCurrentPage('MainPage');
            });
        }

        if (
            currentPage === 'MenuPage' &&
            isShowNavigation === true &&
            isShowProductCard === false
        ) {
            tg.BackButton.show();
            tg.BackButton.onClick(() => {
                setCurrentPage('MainPage');
            });
        }

        if (
            currentPage === 'MenuPage' &&
            isShowNavigation === false &&
            isShowProductCard === false
        ) {
            tg.BackButton.show();
            tg.BackButton.onClick(() => {
                setCurrentPage('MenuPage');
                setIsShowNavigation(true);
            });
        }

        if (currentPage === 'CartPage') {
            tg.BackButton.show();
            tg.BackButton.onClick(() => {
                setCurrentPage('MenuPage');
                setIsShowNavigation(true);
            });
        }

        if (currentPage === 'HistoryPage') {
            tg.BackButton.show();
            tg.BackButton.onClick(() => {
                setCurrentPage('UserPage');
            });
        }

        if (currentPage === 'OrderPage') {
            tg.BackButton.show();
            tg.BackButton.onClick(() => {
                setCurrentPage('HistoryPage');
            });
        }

        if (isShowProductCard) {
            tg.BackButton.show();
            tg.BackButton.onClick(() => {
                setIsShowProductCard(false);
                setIsShowNavigation(false);
            });
        }

        return () => {
            tg.BackButton.offClick(() => {
                setCurrentPage('ContactPage');
            });
            tg.BackButton.offClick(() => {
                setCurrentPage('MainPage');
            });
            tg.BackButton.offClick(() => {
                setCurrentPage('MenuPage');
                setIsShowNavigation(true);
            });
            tg.BackButton.offClick(() => {
                setCurrentPage('UserPage');
            });
            tg.BackButton.offClick(() => {
                setCurrentPage('HistoryPage');
            });
            tg.BackButton.offClick(() => {
                setIsShowProductCard(false);
                setIsShowNavigation(false);
            });
            tg.BackButton.hide();
        };
    }, [currentPage, isShowNavigation, isShowProductCard]);

    const loadingHistory = async () => {
        try {
            const response = await axios.get(
                'https://apihpwild.ru/orders/history',
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'authToken'
                        )}`,
                    },
                }
            );
            if (response.data.success) {
                setHistoryList(response.data.result);
            }
        } catch (error) {
            console.error('Ошибка получения истории заказов ', error);
        }
    };

    const loadingCurrentOrder = async () => {
        try {
            const response = await axios.get(
                'https://apihpwild.ru/orders/currentOrder',
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'authToken'
                        )}`,
                    },
                }
            );
            if (response.data.success) {
                setPaymentList(response.data.result);
            }
        } catch (error) {
            console.error('Ошибка получения оплаты ', error);
        }
    };

    const loadingUserCallTime = async () => {
        try {
            const response = await axios.get(
                'https://apihpwild.ru/rest/user/callTime',
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'authToken'
                        )}`,
                    },
                }
            );
            if (response.data.success) {
                setUserCallTime(response.data.result);
                console.log('Вызовы персонала: ', response.data.result);
            }
        } catch (error) {
            console.error('Ошибка получения оплаты ', error);
        }
    };

    // авторизация
    useEffect(() => {
        const tg = window.Telegram.WebApp;
        if (window.Telegram) {
            tg.expand();
            tg.disableVerticalSwipes();
            tg.lockOrientation();
        }
        if (!tg.initData) {
            alert('Ошибка данных телеграмма');
            return;
        }
        if (!tg.initDataUnsafe.user) {
            alert('Пользователь не найден');
            return;
        }
        const loadingData = async () => {
            const initData = window.Telegram.WebApp.initData;
            try {
                const response = await axios.post(
                    'https://apihpwild.ru/api/auth',
                    {
                        initData: initData,
                        avatarLink: null,
                    },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    }
                );
                if (response.data.success) {
                    const token = response.data.result.token;
                    localStorage.setItem('authToken', token);
                    const age = response.data.result.isLegalAge;
                    setFirstUserName(response.data.result.firstName);
                    setLastUserName(response.data.result.lastName);
                    setTelephoneUser(response.data.result.telephone);
                    await loadingHistory();
                    await loadingCurrentOrder();
                    await loadingUserCallTime();
                    if (age) {
                        console.log('Авторизация:', response.data.result);

                        try {
                            const tableResponse = await axios.get(
                                'https://apihpwild.ru/rest/user/table',
                                {
                                    headers: {
                                        Authorization: `Bearer ${localStorage.getItem(
                                            'authToken'
                                        )}`,
                                    },
                                }
                            );

                            if (tableResponse.data.success) {
                                // setIsUserHavePlace(tableResponse.data.result);
                                setTableId(tableResponse.data.result);
                                setCurrentPage('MainPage');
                                console.log(
                                    'Стол: ',
                                    tableResponse.data.result
                                );
                            }
                        } catch (tableError) {
                            console.error(
                                'Ошибка проверки столика:',
                                tableError
                            );
                        }
                    } else {
                        console.log(
                            'Необходимо подтвердить возраст:',
                            response.data.result
                        );
                        setCurrentPage('AgePage');
                    }
                }
            } catch (error) {
                console.error('Ошибка авторизации ', error);
            }
        };
        loadingData();
    }, []);

    // проверка занятого места
    useEffect(() => {
        if (tableId) {
            setIsUserHavePlace(true);
        }
    }, [tableId]);

    useEffect(() => {
        let tableInterval;

        if (tableId) {
            tableInterval = setInterval(async () => {
                try {
                    const response = await axios.get(
                        'https://apihpwild.ru/rest/user/table',
                        {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem(
                                    'authToken'
                                )}`,
                            },
                        }
                    );

                    if (
                        response.data.success &&
                        response.data.result === null
                    ) {
                        clearInterval(tableInterval);
                        setTableId(null);
                        setIsUserHavePlace(false);
                    }
                } catch (error) {
                    console.error('Ошибка при проверке стола:', error);
                }
            }, 60000);
        }

        return () => {
            if (tableInterval) {
                clearInterval(tableInterval);
            }
        };
    }, [tableId]);

    // клик на кнопку "+"
    const handlePlusClick = (id, name, price) => {
        const newQuantity = (productCount[id]?.quantity || 0) + 1;
        const productInfo = { id, name, price, quantity: newQuantity };

        setProductCount((prev) => ({ ...prev, [id]: productInfo }));
        localStorage.setItem(`product_${id}`, JSON.stringify(productInfo));

        setTotalSum(totalSum + price);
    };

    // клик на кнопку "-"
    const handleMinusClick = (id, price) => {
        const currentProduct = productCount[id];
        if (!currentProduct || currentProduct.quantity <= 0) {
            return;
        }

        const newQuantity = currentProduct.quantity - 1;

        if (newQuantity === 0) {
            localStorage.removeItem(`product_${id}`);
            setProductCount((prev) => {
                const newProductCount = { ...prev };
                delete newProductCount[id];
                return newProductCount;
            });
        } else {
            const productInfo = { ...currentProduct, quantity: newQuantity };
            localStorage.setItem(`product_${id}`, JSON.stringify(productInfo));
            setProductCount((prev) => ({ ...prev, [id]: productInfo }));
        }

        if (newQuantity >= 0) {
            setTotalSum(totalSum - price);
        }
    };

    // закрыть карточку товара
    const handleCloseClick = () => {
        setIsShowProductCard(false);
    };

    useEffect(() => {
        console.log('Выбранный продукт:', selectProduct);
    }, [selectProduct]);

    return (
        <div className='App'>
            {currentPage === 'LoadingPage' && <LoadingPage />}
            {currentPage === 'AgePage' && (
                <AgePage
                    setCurrentPage={setCurrentPage}
                    setIsUserHavePlace={setIsUserHavePlace}
                    setTableId={setTableId}
                />
            )}
            {currentPage === 'NoAccessPage' && <NoAccessPage />}
            {currentPage === 'BookingPage' && (
                <BookingPage
                    setCurrentPage={setCurrentPage}
                    setSuccessStatus={setSuccessStatus}
                    setIsShowSuccess={setIsShowSuccess}
                    setErrorStatus={setErrorStatus}
                    setIsShowError={setIsShowError}
                    telephoneUser={telephoneUser}
                    setTelephoneUser={setTelephoneUser}
                />
            )}
            {isShowProductCard && (
                <ProductPage
                    setCurrentPage={setCurrentPage}
                    selectProduct={selectProduct}
                    productCount={productCount}
                    setProductCount={setProductCount}
                    handleCloseClick={handleCloseClick}
                    totalSum={totalSum}
                    setTotalSum={setTotalSum}
                    handlePlusClick={handlePlusClick}
                    handleMinusClick={handleMinusClick}
                    setIsShowProductCard={setIsShowProductCard}
                />
            )}
            {currentPage === 'MainPage' && (
                <MainPage
                    setCurrentPage={setCurrentPage}
                    firstUserName={firstUserName}
                    lastUserName={lastUserName}
                    isButtonActive={isButtonActive}
                    setIsButtonActive={setIsButtonActive}
                    setIsShowSuccess={setIsShowSuccess}
                    setIsShowError={setIsShowError}
                    setSuccessStatus={setSuccessStatus}
                    setErrorStatus={setErrorStatus}
                    isUserHavePlace={isUserHavePlace}
                    setIsUserHavePlace={setIsUserHavePlace}
                    tableId={tableId}
                    setTableId={setTableId}
                    setIsShowNavigation={setIsShowNavigation}
                    setIsShowProductCard={setIsShowProductCard}
                    loadingUserCallTime={loadingUserCallTime}
                    userCallTime={userCallTime}
                    setIsShowPopUpModal={setIsShowPopUpModal}
                    setSelectProduct={setSelectProduct}
                    setCartItems={setCartItems}
                    setTotalSum={setTotalSum}
                    setProductCount={setProductCount}
                />
            )}
            {currentPage === 'ContactPage' && (
                <ContactPage setCurrentPage={setCurrentPage} />
            )}
            {currentPage === 'InfoPage' && <InfoPage />}

            {currentPage === 'UserPage' && (
                <UserPage
                    setCurrentPage={setCurrentPage}
                    firstUserName={firstUserName}
                    lastUserName={lastUserName}
                />
            )}
            {currentPage === 'PaidPage' && (
                <PaidPage
                    setCurrentPage={setCurrentPage}
                    paymentList={paymentList}
                    loadingCurrentOrder={loadingCurrentOrder}
                />
            )}
            {currentPage === 'BonusPage' && <BonusPage />}
            {currentPage === 'PaidMethodPage' && <PaidMethod />}
            {currentPage === 'MenuPage' && (
                <MenuPage
                    setCurrentPage={setCurrentPage}
                    isShowNavigation={isShowNavigation}
                    setIsShowNavigation={setIsShowNavigation}
                    isShowProductCard={isShowProductCard}
                    setIsShowProductCard={setIsShowProductCard}
                    totalSum={totalSum}
                    setTotalSum={setTotalSum}
                    productCount={productCount}
                    setProductCount={setProductCount}
                    setSelectProduct={setSelectProduct}
                    handleMinusClick={handleMinusClick}
                    handlePlusClick={handlePlusClick}
                />
            )}

            {currentPage === 'CartPage' && (
                <CartPage
                    setCurrentPage={setCurrentPage}
                    setTotalSum={setTotalSum}
                    totalSum={totalSum}
                    setIsShowSuccess={setIsShowSuccess}
                    setSuccessStatus={setSuccessStatus}
                    setIsShowError={setIsShowError}
                    setErrorStatus={setErrorStatus}
                    loadingHistory={loadingHistory}
                    loadingCurrentOrder={loadingCurrentOrder}
                    setProductCount={setProductCount}
                    cartItems={cartItems}
                    setCartItems={setCartItems}
                />
            )}

            {currentPage === 'HistoryPage' && (
                <HistoryPage
                    setCurrentPage={setCurrentPage}
                    historyList={historyList}
                    setOrderList={setOrderList}
                    setIsShowSuccess={setIsShowSuccess}
                    setSuccessStatus={setSuccessStatus}
                    setIsShowError={setIsShowError}
                    setErrorStatus={setErrorStatus}
                />
            )}

            {currentPage === 'OrderPage' && (
                <OrderPage
                    orderList={orderList}
                    setIsShowSuccess={setIsShowSuccess}
                    setSuccessStatus={setSuccessStatus}
                />
            )}

            {[
                'MainPage',
                'ContactPage',
                'InfoPage',
                'UserPage',
                'PaidPage',
                'BonusPage',
                'PaidMethodPage',
                'MenuPage',
                'CartPage',
                'HistoryPage',
                'OrderPage',
            ].includes(currentPage) && (
                <NavigationPanel
                    setCurrentPage={setCurrentPage}
                    currentPage={currentPage}
                    isButtonActive={isButtonActive}
                    setIsShowProductCard={setIsShowProductCard}
                />
            )}

            {isShowSuccess && (
                <SuccessPage
                    setCurrentPage={setCurrentPage}
                    setIsShowSuccess={setIsShowSuccess}
                    successStatus={successStatus}
                />
            )}

            {isShowError && (
                <ErrorPage
                    setCurrentPage={setCurrentPage}
                    setIsShowError={setIsShowError}
                    errorStatus={errorStatus}
                />
            )}

            {isShowPopUpModal && (
                <PopUp
                    isShowPopUpModal={isShowPopUpModal}
                    setIsShowPopUpModal={setIsShowPopUpModal}
                />
            )}
        </div>
    );
}

export default App;
